import { render, staticRenderFns } from "./niveauQuiz.vue?vue&type=template&id=559747a4&scoped=true"
import script from "./niveauQuiz.vue?vue&type=script&lang=js"
export * from "./niveauQuiz.vue?vue&type=script&lang=js"
import style0 from "./niveauQuiz.vue?vue&type=style&index=0&id=559747a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559747a4",
  null
  
)

export default component.exports